export const DEFAULT_CLOSED_MESSAGE =
  "Registration for the Top Shop Challenge 2026 is now closed. Thank you to every shop that applied. You can still join EAB Connect, the free platform from Entrepreneurs Across Borders, for training, tools and mentors that help your business grow for years to come. Create your account below.";

export const CLOSED_MESSAGE_MAX = 2000;

/** Same rule as public.program_applications_are_open. */
export function isRegistrationOpen(applicationsOpen: boolean | null | undefined, closeAt: string | Date | null | undefined, now: Date = new Date()): boolean {
  if (!applicationsOpen) return false;
  if (!closeAt) return true;
  return now.getTime() < new Date(closeAt).getTime();
}

const JM_OFFSET_HOURS = 5; // Jamaica is UTC-5 all year, no daylight saving.

/** Formats e.g. "15 November 2026 at 11:59 pm Jamaica time". */
export function formatJamaicaTime(value: string | Date, withSuffix = true): string {
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: "America/Jamaica", day: "numeric", month: "long", year: "numeric", hour: "numeric", minute: "2-digit", hour12: true,
  }).formatToParts(new Date(value));
  const get = (t: string) => parts.find((p) => p.type === t)?.value ?? "";
  const s = `${get("day")} ${get("month")} ${get("year")} at ${get("hour")}:${get("minute")} ${get("dayPeriod").toLowerCase()}`;
  return withSuffix ? `${s} Jamaica time` : s;
}

/** "YYYY-MM-DDTHH:mm" in Jamaica local time to an ISO timestamp. */
export function jamaicaLocalToIso(local: string): string | null {
  const m = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/.exec(local);
  if (!m) return null;
  const [, y, mo, d, h, mi] = m.map(Number);
  return new Date(Date.UTC(y, mo - 1, d, h + JM_OFFSET_HOURS, mi)).toISOString();
}

/** ISO timestamp to "YYYY-MM-DDTHH:mm" in Jamaica local time. */
export function isoToJamaicaLocal(iso: string | null | undefined): string {
  if (!iso) return "";
  const d = new Date(new Date(iso).getTime() - JM_OFFSET_HOURS * 3600_000);
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())}T${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}`;
}
